export default __webpack_public_path__ + "static/media/ca-bc.3cfab977.svg";